import * as echarts from "echarts";

export const graphicTextStyle = {
    fill: '#fff',
    backgroundColor: '#02516c',
    borderColor: '#056685',
    borderWidth: 1,
    borderRadius: 4,
    padding: [10, 10],
    font: '11px sans-serif',
    lineHeight: 16 // ✅ 控制每行高度
}

export const grid = {
    left: '60px',
    right: '40px',
    top: '50px',
    bottom: '40px'
}

// 工业风格图表配置
export const industrialChartConfig = {
    backgroundColor: 'transparent',
    textStyle: {
        color: '#ffffff'
    },
    grid,
    xAxis: {
        type: 'category',
        axisLine: {
            lineStyle: {
                color: '#E5EEF5'
            }
        },
        axisLabel: {
            color: '#ffffff',
            fontSize: 12
        },
        splitLine: {
            lineStyle: {
                color: 'rgba(0, 212, 255, 0.2)',
                type: 'dashed'
            }
        }
    },
    tooltip:{
        trigger: 'axis',
        confine: true,
        backgroundColor: graphicTextStyle.backgroundColor, // ✅ 背景色
        borderColor: graphicTextStyle.borderColor,
        borderWidth: graphicTextStyle.borderWidth,
        borderRadius: graphicTextStyle.borderRadius,
        padding: graphicTextStyle.padding,
        textStyle: {
            color: graphicTextStyle.fill, // ✅ 正确设置文字颜色
            fontSize: 11,
            lineHeight: graphicTextStyle.lineHeight,
        },
    },
    yAxis: {
        type: 'value',
        nameGap: 30,
        splitNumber: 4,
        nameTextStyle: {
            align: 'left',
            rich: {
                label: {
                    color: "#ffffff", // 改为白色
                    fontWeight: "bold",
                    fontSize: 16,
                    padding: [0, 0, 0, -30]
                },
                unit: {
                    color: '#fff', // 改为工业蓝色半透明
                    fontSize: 12,
                }
            }
        },
        axisLabel: {
            color: '#ffffff',
        },
        splitLine: {
            lineStyle: {
                color: 'rgba(0, 212, 255, 0.2)',
                type: 'dashed'
            }
        }
    },
    legend: {
        top: 40,
        itemGap: 20,
        textStyle: {
            color: '#ffffff'
        }
    },
    toolbox: {
        show: true,
        feature: {
            dataZoom: {
                yAxisIndex: "none",
                iconStyle: {
                    opacity: 0
                }
            },
        }
    },
    // 2. 配置brush组件（直接启用区域选择）
    series:{
        type: "line",
        symbol: 'none',
        lineStyle: {
            width: 2,
            // shadowColor: '#00ff88',
            shadowBlur: 8
        },
    },
    // 亮色线条配置
    seriesColors: ['#06ffa5','#00d4ff', '#9d4edd', '#ff6b35', '#ffd23f', '#ff3366', '#9d4edd']
}
export const timeFormatter = (value)=>{
    const time = echarts.time.format(value, '{MM}-{dd}/{HH}:{mm}', false);
    const arr = time.split('/')
    return arr[1] === '00:00' ? arr[0] : arr[1]
}
export const tooltipFormatter = (params,xunit = '',yunit = '')=>{
    const tooltipContent = params.map((item) => {
        return `
                <div >${item.value[0] + ' ' + xunit}</div>
                <div>
                  <span class="dian" style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background: ${item.color};"></span>
                  <span style="font-weight: bold">${item.value[1] + ' ' + yunit} </span>
                </div>
              `;
    }).join('');  // 使用 join 拼接成完整的 HTML 字符串
    return `<div>${tooltipContent}</div>`
}
export const spectrumToolButtons = ['addMark','doubleCursor','bandCount','harmonics','sideband','dataExport']

export const waveToolButtons = ['addMark','audio','doubleCursor','indicator','dataExport']
